import { createContext } from "react";

const BI_WS0000Context = createContext();

export {BI_WS0000Context}